import { BrowserModule } from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {AisCommonModule, AuthInterceptorService} from 'ais-common';

import localeSk from '@angular/common/locales/sk';
import {registerLocaleData} from '@angular/common';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {MatCardModule} from '@angular/material/card';
import {MatListModule} from '@angular/material/list';
import {MatTabsModule} from '@angular/material/tabs';
import {MatIconModule} from '@angular/material/icon';
import {MatSelectModule} from '@angular/material/select';
import { ZapisnyListSelectorComponent } from './zapisny-list-selector/zapisny-list-selector.component';
import {FormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import { ZnamkyComponent } from './znamky/znamky.component';
import {MatTableModule} from '@angular/material/table';
import { SemesterSelectorComponent } from './semester-selector/semester-selector.component';
import {MatRadioModule} from '@angular/material/radio';
import { SkuskyComponent } from './skusky/skusky.component';
import { PriebezneHodnotenieComponent } from './priebezne-hodnotenie/priebezne-hodnotenie.component';
import { HodnotenieDetailComponent } from './hodnotenie-detail/hodnotenie-detail.component';
import {MatDialogModule} from '@angular/material/dialog';
import { PrehladyComponent } from './prehlady/prehlady.component';
import { UpozorneniaComponent } from './upozornenia/upozornenia.component';
import { TerminDetailComponent } from './termin-detail/termin-detail.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import { TerminZoznamPrihlasenychComponent } from './termin-zoznam-prihlasenych/termin-zoznam-prihlasenych.component';
import {MatChipsModule} from '@angular/material/chips';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import { FilterPredmetPipePipe } from './filter-predmet-pipe.pipe';
import {MatBadgeModule} from '@angular/material/badge';
import {MatMenuModule} from '@angular/material/menu';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { ZnamkyTabulkaComponent } from './znamky-tabulka/znamky-tabulka.component';
import { PriebezneHodnotenieItemComponent } from './priebezne-hodnotenie-item/priebezne-hodnotenie-item.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { PrerekvizityComponent } from './prerekvizity/prerekvizity.component';
import { StudijnyPlanComponent } from './studijny-plan/studijny-plan.component';
import { StudijnyPlanItemComponent } from './studijny-plan-item/studijny-plan-item.component';
import { RozvrhoveAkcieComponent } from './rozvrhove-akcie/rozvrhove-akcie.component';
import { RozvrhovaAkciaComponent } from './rozvrhova-akcia/rozvrhova-akcia.component';
import {MatExpansionModule} from '@angular/material/expansion';
import { PredmetDetailComponent } from './predmet-detail/predmet-detail.component';
import { VyberJazykaComponent } from './vyber-jazyka/vyber-jazyka.component';
import { PredmetZPonukyComponent } from './predmet-z-ponuky/predmet-z-ponuky.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import { DialogHeaderStudentPredmetyComponent } from './dialog-header-student-predmety/dialog-header-student-predmety.component';
import { ProgressSpinnerComponent } from './progress-spinner/progress-spinner.component';
import { DetailAtributovPredmetuComponent } from './detail-atributov-predmetu/detail-atributov-predmetu.component';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatSidenavModule} from '@angular/material/sidenav';

registerLocaleData(localeSk);

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({ declarations: [
        AppComponent,
        ZapisnyListSelectorComponent,
        ZnamkyComponent,
        SemesterSelectorComponent,
        SkuskyComponent,
        PriebezneHodnotenieComponent,
        HodnotenieDetailComponent,
        PrehladyComponent,
        UpozorneniaComponent,
        TerminDetailComponent,
        TerminZoznamPrihlasenychComponent,
        FilterPredmetPipePipe,
        ZnamkyTabulkaComponent,
        PriebezneHodnotenieItemComponent,
        PrerekvizityComponent,
        StudijnyPlanComponent,
        StudijnyPlanItemComponent,
        RozvrhoveAkcieComponent,
        RozvrhovaAkciaComponent,
        DetailAtributovPredmetuComponent,
        PredmetDetailComponent,
        VyberJazykaComponent,
        PredmetZPonukyComponent,
        DialogHeaderStudentPredmetyComponent,
        ProgressSpinnerComponent
    ],
    exports: [
        UpozorneniaComponent,
        PriebezneHodnotenieComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            },
            defaultLanguage: 'sk'
        }),
        AisCommonModule,
        MatCardModule,
        MatListModule,
        MatTabsModule,
        MatIconModule,
        MatSelectModule,
        FormsModule,
        MatButtonModule,
        MatTableModule,
        MatRadioModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        MatSnackBarModule,
        MatChipsModule,
        MatFormFieldModule,
        MatInputModule,
        MatBadgeModule,
        MatMenuModule,
        MatSlideToggleModule,
        MatCheckboxModule,
        MatExpansionModule,
        MatTooltipModule,
        MatSidenavModule,
        MatToolbarModule,
        MatButtonToggleModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptorService,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }
